const SNAT_TICKET_ALLOWED = new Set(['kosexa_snat_ticket', 'super_admin']);

function namesFromGroups(groups) {
  if (!Array.isArray(groups)) return [];
  return groups
    .map((g) => (typeof g?.name === 'string' ? g.name : ''))
    .filter(Boolean);
}

export function canUseSnatTicketFromPayload(payload) {
  if (!payload || typeof payload !== 'object') return false;
  if (payload.is_superuser) return true;
  return namesFromGroups(payload.groups).some((n) => SNAT_TICKET_ALLOWED.has(n));
}

